import { Component } from '@angular/core';

@Component({
	selector: 'sgp-dica-preenchimento-editor',
	templateUrl: './dica-preenchimento-editor.component.html'
})
export class DicaPreenchimentoEditorComponent {}
